import { ELanguageType } from '@hts/shared/enums';
import { SetReactState } from '@hts/shared/types';
import { useCallback, useRef } from 'react';
import { IKeyboardPosState } from '../../types';
import { useCardContextValue } from './context';

interface IUseToogleKeyboardViewProps {
  showKeyboard: boolean;
  setShowKeyboard: SetReactState<boolean>;
  setActiveKeyboardTextFieldId: SetReactState<string | null>;
  setKeyboardLang: SetReactState<ELanguageType>;
  setKeyboardPos: SetReactState<IKeyboardPosState>;
}

export const useToogleKeyboardView = ({
  showKeyboard,
  setActiveKeyboardTextFieldId,
  setKeyboardLang,
  setKeyboardPos,
  setShowKeyboard,
}: IUseToogleKeyboardViewProps) => {
  const card = useCardContextValue('card');

  const keyboard = useRef<any>();

  const offset = useCallback((el: HTMLElement) => {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  }, []);

  const toggleKeyboardView = useCallback(
    (e: React.MouseEvent<HTMLElement>, id: string, language: string) => {
      e.preventDefault();

      if (!showKeyboard) {
        const target = e.currentTarget;
        const inputHolder = target.parentElement;

        if (!inputHolder) return;

        const holderHeight = inputHolder?.offsetHeight;
        const holderWidth = inputHolder?.offsetWidth;
        const holderOffset = offset(inputHolder);

        const currentInput = card?.fields.find((field) => field.id === id);

        if (currentInput) {
          keyboard.current.setInput(currentInput.text);
        }

        setShowKeyboard(true);
        setActiveKeyboardTextFieldId(id);
        setKeyboardPos({
          top: holderHeight + holderOffset.top,
          left: holderOffset.left,
          width: holderWidth,
        });
      } else {
        keyboard.current.setInput('');
        setActiveKeyboardTextFieldId(null);
        setShowKeyboard(false);
      }

      setKeyboardLang(language as ELanguageType);
    },
    [showKeyboard, card]
  );

  return { keyboard, toggleKeyboardView };
};
